<script lang="ts">
	//Stores
	import { sidePanelState, sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { devices } from 'src/stores/lists/devices';
	import { rooms } from 'src/stores/lists/rooms';
	//Design System Components
	import { SidepanelLayout, SidepanelTabs } from '@Shelly/shelly-design-system';
	//Helpers
	import { checkIsComponent } from 'src/components/Sidepanel/sidepanel-helpers';
	//Components - Import all tabs from configurator
	import { Main, Notifications } from './Tabs';
	import Statistics from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/Statistics.svelte';
	import ActivityLog from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/ActivityLog.svelte';

	// Types
	import { TabId, type BaseTab } from 'src/components/Sidepanel/sidepanel-types';
	import { getDeviceStateWithDelay } from 'src/stores/device-runtime/states';
	import { getDeviceChartsConfig } from 'src/helpers/statistics/config/device_chart_config';
	import { getDeviceState } from 'src/stores/device-runtime/states';
	import { createTabsManager } from 'src/components/Sidepanel/createTabsManager';
	import { setSidepanelTabNavigationContext } from 'src/components/Sidepanel/sidepanel-tab-navigation-context';
	import SidePanelSettingsModalProvider from 'src/components/Sidepanel/SidePanelSettingsModal/SidePanelSettingsModalProvider.svelte';
	import { device_notifications } from 'src/stores/features/device-notifications';
	import {
		getCriticalNotifications,
		getNotificationsForDevice,
	} from 'src/helpers/notifications/device_notifications_helper';

	let showSettingsModal = false;

	$: if ($sidePanelState.showSettingsModal === true && !showSettingsModal) {
		showSettingsModal = true;
	}

	$: id = $sidePanelStateCombined?.id;
	$: device = $devices[id];
	$: deviceName = device?.name || 'SBDW-002C';
	$: deviceRoom = $rooms?.[device?.room_id]?.name;
	$: deviceState = getDeviceState(id);
	$: hasStatisticsContent = device ? getDeviceChartsConfig(device).length > 0 : false;

	$: baseTabs = [
		{ id: TabId.MAIN, icon: 'fat fa-sliders-simple', component: Main },
		...(hasStatisticsContent
			? [{ id: TabId.STATISTICS, icon: 'fat fa-chart-line', component: Statistics }]
			: []),
		{ id: TabId.ACTIVITY_LOG, icon: 'fat fa-notebook', component: ActivityLog },
		{ id: TabId.NOTIFICATIONS, icon: 'fat fa-bell', component: Notifications },
	] as BaseTab[];

	const tabsManager = createTabsManager([]);
	$: tabsManager.setBaseTabs(baseTabs);
	$: tabsState = tabsManager.getTabsState();

	const handleSettings = () => (showSettingsModal = true);

	$: hasCriticalNotifs =
		$device_notifications && id
			? getCriticalNotifications(getNotificationsForDevice(id)).length > 0
			: false;
	$: tabs = tabsManager.getTabsConfig($tabsState.tabIndex, device, $deviceState).map((tab) => ({
		...tab,
		...(tab.id === TabId.NOTIFICATIONS && hasCriticalNotifs
			? { notification: 'danger' as const, icon: 'fat fa-bell-on' }
			: {}),
	}));

	$: setSidepanelTabNavigationContext({
		navigateToTab: tabsManager.navigateToTabById,
		getTabIndex: tabsManager.getTabIndexById,
		openedEventTimestamp: $tabsState.openedEventTimestamp,
		activeHistoryButton: $tabsState.activeHistoryButton,
	});

	$: !$sidePanelState.open ? tabsManager.resetActiveTab() : null;
</script>

<SidepanelLayout title={deviceName} subtitle={deviceRoom} onSettings={handleSettings}>
	<svelte:component
		this={checkIsComponent(tabs?.[$tabsState.tabIndex].component)}
		{device}
		{...tabs?.[$tabsState.tabIndex].component === ActivityLog &&
		$tabsState.openedEventTimestamp !== null
			? { openedEventTimestamp: $tabsState.openedEventTimestamp }
			: {}}
	/>
	<SidepanelTabs slot="tabs" {tabs} on:click={tabsManager.onTabClick} />
</SidepanelLayout>

<SidePanelSettingsModalProvider bind:showSettingsModal {device} />
